import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-carregar-ficha',
  templateUrl: './modal-carregar-ficha.component.html'
})
export class ModalCarregarFichaComponent {
  propostaId: number;

  constructor(
    private router: Router,
    private bsModalRef: BsModalRef
  ) {}

  close() {
    this.bsModalRef.hide();
  }

  load() {
    this.router.navigate([`/produtos/cdcloja/fichas/${this.propostaId}`]);
    this.close();
  }
}
